import {number} from 'common/yup';
import i18n from 'i18n';

export const defaultPortSchema = () =>
   number()
      .integer(i18n.t('Should be an integer'))
      .typeError('Invalid Port')
      .min(0, i18n.t('Must be greater than or equal to 0'))
      .max(65535, i18n.t('Must be less than or equal to 65535'));
